module.exports = __webpack_public_path__ + "img/introduction02_contact_03.913b311e.png";